// Toggle debugging logs
window.debugMode = true;
let baseStyles = [
  "color: #fff",
  "background-color: #2759e1",
  "padding: 2px 8px",
  "border-radius: 4px",
].join(";");
function logger() {
  if (window.console && window.debugMode === true) {
    console.log("%cNPSP", baseStyles, ...Array.prototype.slice.call(arguments));
  }
}

window.lpStayAttr = {
  subscriptionChecked: false,
  subscriptionFrequency: 1,
  activePack: 3,
};

// form
const setupForm = () => {
  const changeRegPrice = $(".strikethrough-lg");
  const changeTextSave = $(".text-save");
  const changePercentOffPrice = $(".off-price");
  const changeSalePrice = $(".sale-price");
  const changePieces = $(".v-packs-option");
  const subscriptionSalePrice = $(".subscribe-option .sale-price");
  const stayFrequencies = document.querySelectorAll(".rtx-frequency");
  
  function locGatedMode() {
    logger('locGatedMode');

    // only do if not checked, to fix back button issues
    if (!document.querySelector('.recharge-subscribe').checked) {
      document.querySelector(".rtx-subscribe-label")?.click();
      
      document.querySelectorAll(".rtx-frequency").forEach((stayFrequency) => {
        // logger(stayFrequency.querySelectorAll('option'));
        const oneMonthOption = Array.from(stayFrequency.querySelectorAll('option')).find(option => option.textContent.includes('1 Month'));
        if (oneMonthOption) {
          logger('found 1 month option');
          oneMonthOption.setAttribute('selected', 'selected');
        }
      });
      if (stayFrequencies.length > 0) {
        stayFrequencies[0].dispatchEvent(new Event('change'));
      }
  
      const submitButton = document.querySelectorAll('.button-proceed');
      const postBtn = document.querySelector('.loc-gated--pdp-post-btn');
      if (submitButton && !postBtn) {
        submitButton.forEach(button => {
          const newDiv = document.createElement('div');
          newDiv.classList.add('loc-gated--pdp-post-btn');
          newDiv.innerHTML = 'Free US Shipping.<br>Reschedule or cancel any time.<br>30 day risk-free guarantee.';
          button.insertAdjacentElement('afterend', newDiv);
        })
      }
    }
  }

  const currentVariantId = document.querySelector(
    'input[name="packs_variant_id"]'
  );
  const currentPrice = document.querySelector('input[name="packs_price"]');

  const updateFrequencyFromEl = (triggerEl) => {
    const matches = triggerEl.find("option:selected").text().match(/\d+/);
    logger(["updateFrequencyFromEl", triggerEl, matches]);

    // update selected frequency
    // $(".recharge-frequency").val(triggerEl.val());

    var vFrequency = -1;
    if (matches && matches.length > 0) {
      vFrequency = parseInt(matches[0]);
      window.lpStayAttr.subscriptionFrequency = vFrequency;
    }
  };

  const updateUseCase = () => {
    const vPacks = window.lpStayAttr.activePack;
    const vFrequency = window.lpStayAttr.subscriptionFrequency;
    logger(["updateUseCase", vPacks, vFrequency]);

    var vFamilyUseText = "Perfect for everyday usage families with 2 children";
    if (vPacks == 2 || vPacks == 3) {
      if (vFrequency == 1) {
        vFamilyUseText = "Perfect for everyday usage families with 2 children";
      } else if (vFrequency == 2) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      } else if (vFrequency == 3) {
        vFamilyUseText =
          "Perfect for use a few times a week by families with one child";
      }
    } else if (vPacks == 4) {
      if (vFrequency == 1) {
        vFamilyUseText =
          "Perfect for everyday use by families with three children";
      } else if (vFrequency == 2) {
        vFamilyUseText =
          "Perfect for everyday use by families with two or three children";
      } else if (vFrequency == 3) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      }
    }

    $(".family-use").text(vFamilyUseText);
  };

  const switchSubscriptionPricing = () => {
    logger("switchSubscriptionPricing");
    const listPacks = document.querySelectorAll(".list-packs");

    let priceAttr = "data-price";
    if (window.lpStayAttr.subscriptionChecked) {
      priceAttr = "data-subscription-price";
    }

    listPacks.forEach((listPack) => {
      const pack = listPack.getAttribute("data-pack");
      const packPrice = listPack.querySelector(".pack-price");
      const regPrice = listPack.querySelector(`.reg-price-${pack}`);
      const savePrice = listPack.querySelector(`.save-price-${pack}`);
      const savePercent = listPack.querySelector(`.save-percent-${pack}`);

      packPrice.innerText = packPrice.getAttribute(priceAttr);

      if (regPrice !== null) {
        regPrice.innerText = regPrice.getAttribute(priceAttr);
        savePrice.innerText = savePrice.getAttribute(priceAttr);
        savePercent.innerText = savePercent.getAttribute(priceAttr);
      }
    });
  };

  const updateActivePrices = () => {
    const pack = window.lpStayAttr.activePack;
    logger(["updateActivePrices", pack]);

    $(".list-packs").removeClass("active-slide");

    if (pack == 1) {
      $(".np-multiple-pack").hide();
      $(".np-one-pack").show();
    } else {
      $(".np-multiple-pack").show();
      $(".np-one-pack").hide();
    }

    const listPacks = document.querySelectorAll(
      `.list-packs[data-pack="${pack}"]`
    );

    let priceAttr = "data-price";
    if (window.lpStayAttr.subscriptionChecked) {
      priceAttr = "data-subscription-price";
    }

    listPacks.forEach((listPack) => {
      changeRegPrice.html(
        listPack.querySelector(`.reg-price-${pack}`).getAttribute(priceAttr)
      );
      changePercentOffPrice.html(
        listPack.querySelector(`.save-percent-${pack}`).getAttribute(priceAttr)
      );
      changeSalePrice.html(
        listPack.querySelector(`.save-price-${pack}`).getAttribute(priceAttr)
      );
      changeTextSave.html(
        listPack.querySelector(`.text-save-${pack}`).getAttribute(priceAttr)
      );
      changePieces.html(listPack.querySelector(`.pcs-${pack}`).innerHTML);
      subscriptionSalePrice.html(
        listPack
        .querySelector(`.save-price-${pack}`)
        .getAttribute("data-subscription-price")
        );
        
      currentVariantId.value = listPack.getAttribute("data-id");
      listPack.classList.add("active-slide");
    });
  };

  // default
  updateActivePrices();
  updateUseCase();

  // change active pack
  $(".list-packs").on("click", function (e) {
    logger("list-packs click");
    e.preventDefault();
    e.stopPropagation();
    window.lpStayAttr.activePack = $(this).attr("data-pack");

    // if data-pack is 1
    if (window.lpStayAttr.activePack == 1) {
      logger("list-packs[data-pack='1'] click");
      $(".np-multiple-pack").hide();
      $(".rtx-subscribe-label").prop("checked", false);
      $(".rtx-frequency").val($(".rtx-frequency option:first").val());
      $(".subscribe-frequency").hide();
      $(".np-one-pack").show();
      $(".hide-price-pack").hide();
      $('.loc-gated--lp-above-btn').hide();
      resetSelectedSubscription()
    } else {
      $('.loc-gated--lp-above-btn').show();
      if (window.lpStayAttr.subscriptionChecked == true) {
        $(".subscribe-frequency").show();
        $(".np-multiple-pack").show();
      } 
      
      $(".hide-price-pack").show();
    }

    updateActivePrices();
  });

  // add to cart
  $(".button-proceed").on("click", function (e) {
    logger("button-proceed click");
    e.preventDefault();
    e.stopPropagation();

    let stayFrequency = '';
    const targetEl = e.target.parentElement
    const frequencyEl = targetEl.querySelector('.rtx-frequency');
    const frequency = frequencyEl?.value

    if ($("#rtxSubscribe").is(":checked")) {
      const mainFrequencyVal = $(".rtx-frequency").val()
      stayFrequency = frequency || mainFrequencyVal;
    }

    addItemToCart(currentVariantId.value, 1, stayFrequency);
    return false;
  });

  const productHandle = window.product.handle;
  $.getJSON(
    `${window.Shopify.routes.root}products/${productHandle}.js`,
    (product) => {
      const staySelligPlan = product.selling_plan_groups.find((plan) => plan.app_id === '5859381')
      if (product.selling_plan_groups.length < 0 && !staySelligPlan) {
        $(".stay-container").hide();
        return;
      }

      const sellingPlans = staySelligPlan.selling_plans;
      sellingPlans.forEach((plan) => {
        const planValue = plan.options[0].value.toLowerCase()
        const frequency = planValue.split(' ')[0]
        if (planValue.includes('week') || (Number(frequency) && Number(frequency) > 3) ) return
        const option = document.createElement("option");
        option.value = plan.id;
        option.text = plan.name.replace("Delivery e", "E");
        $(".rtx-frequency").append(option);
      });

      window.addEventListener('locGateHideContent', (event) => {
        logger('locGateHideContent event triggered', event);
        locGatedMode();
      });
    
      logger(['checking window.locGated', window.locGated]);
      if (window.locGated === true) {
        locGatedMode();
      }
    }
  );


  /**
   * Removes the iCart element
   */
  const removeICart = () => {
    $('body > .icart').remove();
  };
  

  // based on
  // https://support.rechargepayments.com/hc/en-us/articles/360008683774-Adding-an-item-to-the-cart-with-AJAX
  function addItemToCart(variant_id, qty, selling_plan) {
    logger(["addItemToCart", variant_id, qty, selling_plan]);
    data = {
      id: variant_id,
      quantity: qty,
      selling_plan: selling_plan
    };
    if (selling_plan > 0) {
      data["selling_plan"] = selling_plan;
    }
    logger(["data", data]);

    const product = window.product;

    // fbq_data = {
    //   content_name: product.title,
    //   content_ids: product.id,
    //   content_type: "product_group",
    //   value: currentPrice.value,
    //   currency: product.currency,
    // };
    // logger(["fbq_data", fbq_data]);
    // fbq("track", "AddToCart", fbq_data);
    // fbq("track", "InitiateCheckout", fbq_data);
    
    // make sure iCart is gone
    removeICart();

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        // have to timeout to outsmart iCart opening
        setTimeout(function () {
          window.location.href = "/checkout";
        }, 1000);
        return false;
      },
    });
  }

  $(".stay-container a").click(function (e) {
    logger("stay-container a click");
    e.preventDefault();
  });

  $(".rtx-subscribe-label").click(function (e) {
    logger("rtx-subscribe-label click");
    e.preventDefault();
    e.stopPropagation();
    const rechargeCheckbox = $(".recharge-subscribe");
    const subscribeFrequency = $(".subscribe-frequency");

    if ($(this).siblings(".recharge-subscribe").is(":checked")) {
      window.lpStayAttr.subscriptionChecked = false;
      subscribeFrequency.hide();
      rechargeCheckbox.prop("checked", false);
    } else {
      window.lpStayAttr.subscriptionChecked = true;
      rechargeCheckbox.prop("checked", true);
      subscribeFrequency.show();
    }

    switchSubscriptionPricing();
    updateActivePrices();
  });

  stayFrequencies.forEach((stayFrequency) => {
    stayFrequency.addEventListener("change", () => {
      updateFrequencyFromEl($(stayFrequency));
      updateUseCase();
    });
  });
};

// scrolling
const setupScrollActions = () => {
  $("#to-top").click(function () {
    logger("to-top click");
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      500
    );
  });
  $(window).scroll(function () {
    // logger("window scroll");
    var t = $(window).scrollTop();
    t >= 501 && $(".navbar").addClass("fixed-top"),
      t <= 500 && $(".navbar").removeClass("fixed-top");
  });
  setTimeout(function () {
    $(window).scroll(function () {
      // logger("window scroll 2");
      let scrollJS = $(window).scrollTop();
      let fixCompareJS = $(".nav-fix-compare");
      let mobCompareTableJS = $(".bp-mob-table-container").offset().top;
      let bottomLine =
        $(".bp-mob-table-container > hr:nth-child(26)").offset().top - 50;
      let navHeightJS = $(".navbar .container").outerHeight() + 10;

      if (
        scrollJS > mobCompareTableJS - navHeightJS &&
        scrollJS != mobCompareTableJS - navHeightJS
      ) {
        fixCompareJS.css("display", "flex");
        if (scrollJS > bottomLine - navHeightJS) {
          fixCompareJS.css("display", "none");
        }
      } else {
        fixCompareJS.css("display", "none");
      }
    });
  }, 1000);
};

// slider
const setupSlider = () => {
  const openBtns = document.querySelectorAll("#open");
  const closeBtn = document.querySelector(".close-btn");
  const disableSidebar = document.querySelector(".sidebar");
  const sidebar = document.querySelector(".sidebar");
  const cons = document.querySelector("#cons");
  const addBodyClass = document.querySelector("body");

  const closeFunction = () => {
    logger("closeFunction");
    cons.style.transform = "translateX(700px)";
    setTimeout(() => {
      sidebar.classList.remove("active-sidebar");
      sidebar.style.width = "0%";
      sidebar.style.position = "absolute";
      addBodyClass.style.overflowY = "visible";
      addBodyClass.classList.remove("slide");
    }, 300);
  };

  disableSidebar.addEventListener("click", (e) => {
    logger("disableSidebar click");
    let xPosition = e.clientX;
    const widthOfSectionSideBar = disableSidebar.clientWidth;
    const widthOfSidebar = cons.offsetWidth;
    if (
      xPosition < widthOfSectionSideBar - widthOfSidebar &&
      sidebar.classList.contains("active-sidebar")
    ) {
      closeFunction();
    }
  });

  openBtns.forEach((openBtn) => {
    openBtn.addEventListener("click", (e) => {
      logger("openBtn click");
      e.preventDefault();
      sidebar.classList.add("active-sidebar");
      sidebar.style.width = "100%";
      sidebar.style.position = "fixed";
      cons.style.transform = "translateX(0px)";
      addBodyClass.classList.add("slide");
    });
  });

  closeBtn.addEventListener("click", () => {
    logger("closeBtn click");
    closeFunction();
  });
};

const resetSelectedSubscription = () => {
  const rtxForm = document.querySelectorAll('input[name="rtxSubscribe"')
  rtxForm.forEach((input) => input.checked = false)
  window.lpStayAttr.subscriptionChecked = false;
}

$(document).ready(function () {
  $(".shopify-section-group-header-group").remove();
  $("body").addClass("sleepypatch-template");
  $('[data-toggle="np-tooltip"]').tooltip();

  setupScrollActions();
  setupForm();
  setupSlider();

  // accordion

  $("#accordion-SP .collapse")
    .on("shown.bs.collapse", function () {
      $(this).parent().find(".down").removeClass("down").addClass("up");
      var $showCard = $(this).closest(".card-SP");
      $("html,body").animate(
        {
          scrollTop: $showCard.offset().top - 85,
        },
        500
      );
    })
    .on("hidden.bs.collapse", function () {
      $(this).parent().find(".up").removeClass("up").addClass("down");
    });

  // video modal

  $("#vid-modal1")
    .on("show.bs.modal", function () {
      $("#js-video")[0].play();
    })
    .on("hide.bs.modal", function () {
      $("#js-video")[0].pause();
    });

  // carousel

  $(".slider").slick({
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 3,
    arrows: true,
    nextArrow: ".arrowRight",
    prevArrow: ".arrowLeft",
    dots: true,
    dotsClass: "dots",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
    ],
  });
  $('.subscribe-frequency .itool-skip').click(function(){
     event.preventDefault(); 
  });
});
